import React, { PureComponent, Fragment } from 'react';

import { FormattedMessage } from 'react-intl';

import CustomThemeButton from '@atlaskit/button/custom-theme-button';
import Spinner from '@atlaskit/spinner';

import GenericMessage from 'src/components/generic-message';
import { CommitList } from 'src/containers/commit-list';
import { Loading } from 'src/sections/global/components/loading.style';

import FileHistoryProvider, { RenderProps } from './file-history-provider';
import messages from './file-history.i18n';

type FileHistoryProps = {
  path: string;
  refOrHash: string | null | undefined;
  repositoryFullSlug: string | null | undefined;
};

export default class FileHistory extends PureComponent<FileHistoryProps> {
  render() {
    const { path, refOrHash, repositoryFullSlug } = this.props;

    if (!refOrHash || !repositoryFullSlug) {
      return (
        <Loading>
          <Spinner size="large" />
        </Loading>
      );
    }

    return (
      <FileHistoryProvider
        path={path}
        refOrHash={refOrHash}
        repositoryFullSlug={repositoryFullSlug}
        render={(fileHistoryProps: RenderProps) => (
          <Fragment>
            <CommitList
              commits={fileHistoryProps.commits}
              hasMore={fileHistoryProps.hasMore && !fileHistoryProps.hasError}
              isLoading={fileHistoryProps.isLoading}
              onShowMoreClick={fileHistoryProps.loadMore}
              repositoryFullSlug={repositoryFullSlug}
            />
            {fileHistoryProps.hasError && !fileHistoryProps.isLoading && (
              <GenericMessage
                iconType="error"
                title={<FormattedMessage {...messages.errorHeader} />}
              >
                <FormattedMessage tagName="p" {...messages.errorDescription} />
                <CustomThemeButton
                  appearance="link"
                  onClick={() => fileHistoryProps.loadMore()}
                >
                  <FormattedMessage {...messages.errorLink} />
                </CustomThemeButton>
              </GenericMessage>
            )}
          </Fragment>
        )}
      />
    );
  }
}
